/**
 * Return true or false if user can access the route
 * Evaluates allowedRoles, onlyAdmin, onlySuperAdmin, super admin and external_jwt.
 *
 * @param {Object} route - The route configuration.
 * @param {Object} userProfile - The current user's profile.
 * @param {string|null} external_jwt - Token external (Optional).
 * @returns {boolean} - true if access is allowed.
 */

const canAccessRoute = (route, userProfile, external_jwt) => {
	return (
		(
			Boolean(route?.allowedRoles?.length) === false &&
			Boolean(route?.onlyAdmin) === false &&
			Boolean(route?.onlySuperAdmin) === false
		) || // si no hay allowedRoles, onlyAdmin o onlySuperAdmin, permitir
		route?.allowedRoles?.includes(userProfile?.role_code) || // si el rol del usuario está en allowedRoles, permitir
		(
			Boolean(route?.onlyAdmin) &&
			(
				userProfile?.is_admin ||
				userProfile?.is_super_admin
			)
		) || // si onlyAdmin es true y el usuario es admin o super admin, permitir
		(
			Boolean(route?.onlySuperAdmin) &&
			userProfile?.is_super_admin
		) || // si onlySuperAdmin es true y el usuario es super admin, permitir
		userProfile?.is_super_admin || // si el usuario es super admin, permitir
		external_jwt != null // Si tiene JWT externo
	)
}

export default canAccessRoute;